import {type} from '../constants/manageNumbersConstant'
import { UnsubscribeNumberReducer } from '../models/manageNumbers.interface';

const initialState: UnsubscribeNumberReducer = {
    cancelNumberInit: false,
    cancelNumberSuccess: false,
    cancelNumberError: false,
    cancelNumberErrorMsg: ''
}

const unsubscribeNumberReducer = (state: UnsubscribeNumberReducer = initialState, action: any): UnsubscribeNumberReducer => {

    switch (action.type) {
        case type.CANCEL_NUMBER_SUBSCRIPTION_INIT:
            return {
                ...state,
                cancelNumberInit: true,
                cancelNumberError: false,
                cancelNumberSuccess: false,
            }
        case type.CANCEL_NUMBER_SUBSCRIPTION_SUCCESS:
            return {
                ...state,
                cancelNumberInit: false,
                cancelNumberSuccess: true,
            }
        case type.CANCEL_NUMBER_SUBSCRIPTION_FAILED:
            return {
                ...state,
                cancelNumberInit: false,
                cancelNumberError: true,
                cancelNumberErrorMsg: action.payload.error
            }
        default:
            return state;
    }
}

export default unsubscribeNumberReducer;